<template>
  <span
    class="c-line line"
    :class="{ 'line--small': isSmall }"
    :data-animation="isAnimated ? 'line' : false"
  />
</template>

<script>
export default {
  name: 'AppLine',
  props: {
    isSmall: {
      type: Boolean,
      required: false,
      default: false,
    },
    isAnimated: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.line {
  display: block;
  position: relative;
  width: 100%;
  height: 1px;
  margin: $unit-vh 0;

  background-color: $color-white;
  opacity: 0.4;

  @include mq(ipadP) {
    &--small {
      width: $unit-vw * 40;
    }
  }

  @include mq(ds) {
    margin: $unit-vh * 1.5 0;
  }
}
</style>
